import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
function useCreateWorkspaceConfig() {
  return useMutation(function (_ref) {
    var workspaceId = _ref.workspaceId,
      data = _ref.data;
    return servicesUtils.postService("/acr/config/".concat(workspaceId, "/"), data);
  });
}
export default useCreateWorkspaceConfig;